module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_337.5deg.ca499938.png";